<p-autoComplete [(ngModel)]="landlord" (ngModelChange)="landlordChange.emit($event)"
                name="landlord" [disabled]="mode !== DetailMode.EDITION"
                class="acted-highlight-req metadata-field" [required]="required"
                [suggestions]="allLandlords" optionLabel="code" (completeMethod)="getLandlordSuggestions($event)"
                [multiple]="false" [forceSelection]="true"
                [dropdown]="false" dropdownMode="current" i18n-placeholder="@@common-none" placeholder="(none)"
                appendTo="body" [tabindex]="tabindex">
  <ng-template pTemplate="item" let-landlord>
    {{ landlord.code }} ({{ landlord.full_name }})
  </ng-template>
</p-autoComplete>
<!-- Put back [minQueryLength]="2" once this bug is fixed: https://github.com/primefaces/primeng/issues/19218           -->

@if (mode === 'edition' && recommended && !this.landlord) {
  <app-required-field-text/>
}
